<template>
    <v-form v-model="valid" ref="invoiceStepForm">
        <v-layout row wrap>
            <v-flex xs12 class="title">Rechnungdaten</v-flex>
            <v-flex v-if="isFree && organizer.slug !== 'mbb'" xs12 class="subheading">Aus buchhalterischen Gründen erhalten Sie auch bei kostenfreien Veranstaltungen eine Proformarechnung über den Betrag von 0,- € per E-Mail zugeschickt.</v-flex>
            <v-flex xs12>
                <v-layout row wrap>
                    <v-flex grow>
                        <s-select :items="attendees" item-text="full_name" item-value="id" clearable v-model="selectedAttendee"
                                  label="Teilnehmerdaten übernehmen"></s-select>
                    </v-flex>
                    <v-flex shrink>
                        <v-btn @click="copyAttendee" :disabled="selectedAttendee===undefined">Anwenden</v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md6>
                <s-text-field
                    v-model="invoiceRecipient.email"
                    label="E-Mail"
                    :rules="rules.email"
                    name="email"
                >
                </s-text-field>
            </v-flex>
            <v-flex xs12 md6>
                <s-text-field
                    v-model="invoiceRecipient.repeatEmail"
                    label="E-Mail wiederholen"
                    :rules="rules.repeatEmail"
                ></s-text-field>
            </v-flex>
            <v-flex xs12 md6>
                <s-text-field
                    v-model="invoiceRecipient.company"
                    label="Firma (optional)"
                    :rules="rules.company"
                    name="organization"
                >
                </s-text-field>
            </v-flex>
            <v-flex xs12 md6>
                <s-text-field
                    v-model="invoiceRecipient.tax_nr"
                    label="USt.-Id. (optional)"
                    :rules="rules.tax_nr"
                    name="tax_nr"
                ></s-text-field>
            </v-flex>
            <v-flex xs12 md6>
                <s-select
                    v-model="invoiceRecipient.salutation"
                    label="Anrede"
                    :items="['Herr', 'Frau']"
                    :rules="rules.salutation"
                    name="salutation"
                    browser-autocomplete="false"
                    clearable
                >
                </s-select>
            </v-flex>
            <v-flex xs12 md6>
                <s-select
                    v-model="invoiceRecipient.title"
                    label="Titel (optional)"
                    :items="['Dr.', 'Prof.', 'Prof. Dr.', 'PD', 'PD Dr.']"
                    clearable
                    name="title"
                    browser-autocomplete="false"
                >
                </s-select>
            </v-flex>
            <v-flex xs12 md6>
                <s-text-field
                    v-model="invoiceRecipient.first_name"
                    label="Vorname"
                    :rules="rules.first_name"
                    name="fname"
                >
                </s-text-field>
            </v-flex>
            <v-flex xs12 md6>
                <s-text-field
                    v-model="invoiceRecipient.last_name"
                    label="Nachname"
                    :rules="rules.last_name"
                    name="lname"
                ></s-text-field>
            </v-flex>
            <v-flex xs12 md6>
                <s-text-field
                    v-model="invoiceRecipient.street"
                    label="Straße, Hausnummer"
                    :rules="rules.street"
                    name="street"
                >
                </s-text-field>
            </v-flex>
            <v-flex xs12 md6>
                <s-text-field
                    v-model="invoiceRecipient.street_suffix"
                    label="Adresszusatz (optional)"
                    :rules="rules.street_suffix"
                    name="street_suffix"
                ></s-text-field>
            </v-flex>
            <v-flex xs12 md6>
                <s-text-field
                    v-model="invoiceRecipient.postcode"
                    label="PLZ"
                    :rules="rules.postcode"
                    name="plz"
                >
                </s-text-field>
            </v-flex>
            <v-flex xs12 md6>
                <s-text-field
                    v-model="invoiceRecipient.city"
                    label="Ort"
                    :rules="rules.city"
                    name="city"
                ></s-text-field>
            </v-flex>
            <v-flex xs12>
                <s-select
                    v-model="invoiceRecipient.country_code"
                    label="Land"
                    :items="countries"
                    :rules="rules.country_code"
                    name="country"
                    browser-autocomplete="false"
                >
                </s-select>
            </v-flex>
            <v-flex xs12>
                <v-layout row wrap>
                    <v-flex shrink>
                        <button-previous></button-previous>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex shrink>
                        <button-next @click="nextButtonClick()"></button-next>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-form>
</template>

<script>
    import {mapState} from 'vuex'
    import {mapMutations} from 'vuex'
    import {mapActions} from 'vuex'

    export default {
        name: "InvoiceStep",
        data() {
            return {
                valid: false,
                copy_data: true,
                selectedAttendee: undefined,
                rules: this.$validation.create({
                        email: ['required', 'email', 'maxLen:255'],
                        repeatEmail: ['required', (v) => (v === this.invoiceRecipient.email || 'E-mail Adressen stimmen nicht überein.')],
                        company: ['maxLen:255'],
                        tax_nr: ['maxLen:255'],
                        salutation: [v => !!v || !!this.invoiceRecipient.company || 'Dieses Feld ist ein Pflichtfeld'],
                        first_name: [v => !!v || !!this.invoiceRecipient.company || 'Dieses Feld ist ein Pflichtfeld', 'maxLen:140'],
                        last_name: [v => !!v || !!this.invoiceRecipient.company || 'Dieses Feld ist ein Pflichtfeld', 'maxLen:140'],
                        street: ['required', 'maxLen:255'],
                        street_suffix: ['maxLen:255'],
                        postcode: ['required', 'maxLen:255'],
                        city: ['required', 'maxLen:255'],
                        country_code: ['required'],
                    }
                )
            }
        },
        computed: {
            ...mapState('form',[
                'countries',
                'tickets',
                'invoiceRecipient',
                'isFree',
                "organizer",
            ]),
            attendees() {
                let attendees = _.flatten(Object.values(_.cloneDeep(this.$store.state.form.attendees)));
                _.each(attendees, (attendee, idx) => {
                    attendee.full_name = '';
                    attendee.full_name += _.has(attendee, 'salutation') ? attendee.salutation + ' ' : '';
                    attendee.full_name += _.has(attendee, 'title') && !!attendee.title ? attendee.title + ' ' : '';
                    attendee.full_name += _.has(attendee, 'first_name') ? attendee.first_name + ' ' : '';
                    attendee.full_name += _.has(attendee, 'last_name') ? attendee.last_name + ' ' : '';
                    attendee.id = idx;
                });
                return attendees;
            },
        },
        methods: {
            ...mapMutations('stepper', [
                'nextStep'
            ]),
            ...mapMutations('form', [
                'setInvoiceRecipient',
            ]),
            ...mapActions('form', [
                'setError',
            ]),
            nextButtonClick() {
                if (this.$refs.invoiceStepForm.validate()) {
                    this.nextStep();
                } else {
                    this.setError('Bitte überprüfen Sie Ihre Eingaben.');
                }
            },
            copyAttendee() {
                if (!this.selectedAttendee !== undefined)
                    this.setInvoiceRecipient(this.attendees[this.selectedAttendee]);
            },
        },
    }
</script>

<style scoped>

</style>
